<div
  data-id="bd-access-denied"
  *transloco="let t; scope: 'uiComponents'; prefix: 'uiComponents'"
>
  <div
    class="flex absolute inset-0 h-screen w-screen justify-center items-center"
  >
    <bd-call-to-action
      [title]="{ textKey: 'accessDenied.title', tScope: 'uiComponents' }"
      [subtitle]="{ textKey: 'accessDenied.subtitle', tScope: 'uiComponents' }"
      [actionButton]="actionButton"
      ><span class="bd-display-large">{{
        t('accessDenied.code')
      }}</span></bd-call-to-action
    >
  </div>
</div>
